import { useMutation } from '@tanstack/react-query'
import { useProfile } from '../../profile/hooks/useProfile'
import { ClientMethodsTypes, client } from '@/services/v2/client'
import { useRouter } from 'next/router'

const endpointUrl = '/api/v1/users'

export const useMixPanelTracker = () => {
  const { profile } = useProfile()
  const router = useRouter()

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (event?: string | void) => {
      // Current url path
      const currentPath = router.asPath

      return client(`${endpointUrl}/profile-views/profile-view`, {
        method: ClientMethodsTypes.POST,
        headers: {
          xUrl: currentPath,
          xEvent: event || undefined,
          profilePageId: profile?.id,
        },
      })
    },
  })
  return {
    track: mutateAsync,
    ...rest,
  }
}
